import { render, staticRenderFns } from "./structure.vue?vue&type=template&id=af12e17a&scoped=true"
import script from "./structure.vue?vue&type=script&lang=js"
export * from "./structure.vue?vue&type=script&lang=js"
import style0 from "./structure.vue?vue&type=style&index=0&id=af12e17a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af12e17a",
  null
  
)

export default component.exports